import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, ScrollView, StyleSheet, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import AsyncStorage from '@react-native-async-storage/async-storage';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import FilledButton from '../../components/FilledButton';
import PtfKeyboardAvoidingView from '../../components/PtfKeyboardAvoidingView';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    alignItems: 'center',
  },
  emailContainer: {
    marginTop: 132,
  },
  headerText: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 20 : 26,
    color: Colors.veryDarkGray,
    textAlign: 'center',
    marginTop: Layout.isSmall ? 34 : 50,
    width: 328,
  },
  text: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 14 : 16,
    color: Colors.veryDarkGray,
    textAlign: 'center',
    marginTop: Layout.isSmall ? 16 : 8,
    width: Layout.isSmall ? 269 : 330,
  },
  image: {
    height: 101,
    width: 69,
    resizeMode: 'contain',
    marginTop: Layout.isSmall ? 33 : 79,
    marginLeft: -10,
  },
  form: {
    marginLeft: -15, // to align inputs within form
    marginBottom: 16,
    padding: 0,
    width: 345,
  },
  input: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'roboto-regular',
  },
  signupContainer: Layout.signupContainer,
  signupFooter: Layout.signupFooter,
  linkContainer: {
    paddingHorizontal: 16,
    paddingTop: Layout.isSmall ? 20 : 32,
    paddingBottom: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  doNotAskContainer: {
    flexDirection: 'row',
  },
  checkbox: {
    width: 32,
  },
  label: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 16 : 14,
    color: Colors.veryDarkGray,
  },
});

class LoginByMagicLinkScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    this.state = {};
    this.scroll = null;
  }

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('PhoneOrEmail');
  };

  goNext = () => {
    const { actions, navigation, route } = this.props;
    const magicLinkToken = route.params.token;

    actions.loginByMagicLink(magicLinkToken, (user) => {
      if (!user.phone && !user.skip_phone_ask) {
        navigation.navigate('EnterPhone');
      } else if (user.docs && user.docs.length) {
        navigation.navigate('TermsPrivacy');
      } else if (!user.onboarding_complete) {
        navigation.navigate('UserDetails');
      } else {
        AsyncStorage.setItem('onboarded', '1').then(() => {
          actions.refreshRedux();
          navigation.navigate('a');
        });
      }
    });
  };

  render() {
    const { route } = this.props;
    const lang = route.params.lang;

    const isValidLang = Object.keys(Languages.translations).includes(lang);

    const translation = Languages.translations[isValidLang ? lang : 'en'];

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <PtfKeyboardAvoidingView style={{ flex: 1 }}>
          <ScrollView
            contentContainerStyle={styles.mainContentContainer}
            style={styles.container}
            testID="enter-email"
          >
            <Header title={translation.sign_in} goBack={this.goBack} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <Image source={require('../../assets/images/sign_up/image_36.png')} style={styles.image} />
                <Text style={styles.headerText}>{translation.confirm_magic_link_login}</Text>
              </View>
              <View style={styles.signupFooter}>
                <FilledButton
                  onPress={this.goNext}
                  label={translation.fragment_registration_language_button_next}
                  color={Colors.primaryColor}
                  full
                  textColor={Colors.white}
                  testID="button-next"
                />
              </View>
            </View>
          </ScrollView>
        </PtfKeyboardAvoidingView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginByMagicLinkScreen);
